
  import { mapGetters } from 'vuex';
  import { Address } from '@/scripts/address';
  import { ADDRESS_FIELDS } from '@/constants/addresses';

  export default {
    props: {
      ctaText: { type: String, default: '' },
      icon: { type: String, required: true }
    },
    data () {
      return {
        addressFields: ADDRESS_FIELDS,
        loading: false
      };
    },
    computed: {
      ...mapGetters('user', { user: 'get' }),
      ...mapGetters('utils', { addressGetter: 'getAddress' }),
      address () {
        return this.user.supply_address || this.addressGetter;
      },
      canonicalAddress () {
        return this.address ? new Address(this.address).canonical : null;
      },
      formattedAddressParts () {
        if (this.canonicalAddress) {
          const addressParts = this.addressFields.map(field =>
            this.canonicalAddress[field === 'eircode' ? 'displayEircode' : field]
          );
          return addressParts
            .map((part, index) => {
              if (part !== undefined) {
                return {
                  text: part,
                  class: index < addressParts.length - 2 ? 'bold' : 'light'
                };
              }
              return null;
            })
            .filter(part => part !== null);
        } else {
          return [];
        }
      }
    },
    methods: {
      clickedButton () {
        if (this.loading) return;
        this.loading = true;
        this.$emit('submitAddress');
      },
      clickedUpdateToggle () {
        if (this.loading) return;
        this.$emit('edit');
      }
    }
  };
